import { Component, computed, inject, model, output } from '@angular/core';
import { TenantContext, TenantService } from '../../../core/services/tenant.service';
import { CompanyOption } from '../models/company-option.model';
import { formatCnpj } from '../../../shared/utils/format-cnpj.util';

/**
 * Seletor de empresa (tenant) ativa na topbar. Apenas exibe/abre a lista —
 * a orquestração da troca (setActiveTenant + reload de permissões/módulos +
 * navegação) fica no TopbarComponent, para não duplicar essa lógica em
 * múltiplos componentes de apresentação.
 */
@Component({
  selector: 'app-company-selector',
  standalone: true,
  imports: [],
  templateUrl: './company-selector.component.html',
  styleUrl: './company-selector.component.scss',
})
export class CompanySelectorComponent {
  private readonly tenantService = inject(TenantService);

  /** Controlado externamente (ex.: "Trocar empresa" no menu do usuário). */
  readonly open = model<boolean>(false);
  readonly companyChange = output<TenantContext>();

  readonly activeTenant = this.tenantService.activeTenant;
  readonly activeTenantDoc = computed(() => formatCnpj(this.activeTenant()?.cpfCnpj));
  readonly options = computed<CompanyOption[]>(() =>
    this.tenantService.availableTenants().map(t => ({ id: t.id, name: t.name, cpfCnpj: t.cpfCnpj }))
  );
  readonly hasMultiple = computed(() => this.tenantService.availableTenants().length > 1);

  formatDoc(cpfCnpj: string | undefined): string | undefined {
    return formatCnpj(cpfCnpj);
  }

  toggle(): void {
    if (!this.hasMultiple()) return;
    this.open.update(v => !v);
  }

  close(): void {
    this.open.set(false);
  }

  select(option: CompanyOption): void {
    const tenant = this.tenantService.availableTenants().find(t => t.id === option.id);
    this.close();
    if (tenant) {
      this.companyChange.emit(tenant);
    }
  }
}
